import * as React from "react";
const SvgCheveronUp = props => <svg xmlns="http://www.w3.org/2000/svg" width={800} height={800} viewBox="0 0 20 20" {...props}><path d="M10.707 7.05 10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z" /></svg>;
export default SvgCheveronUp;